import { render, staticRenderFns } from "./PostcodeCheckerWidget.vue?vue&type=template&id=c67022ca&scoped=true"
import script from "./PostcodeCheckerWidget.vue?vue&type=script&lang=ts"
export * from "./PostcodeCheckerWidget.vue?vue&type=script&lang=ts"
import style0 from "./PostcodeCheckerWidget.vue?vue&type=style&index=0&id=c67022ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67022ca",
  null
  
)

export default component.exports